export default {
  plan: {
    cardDetails: 'plan.cardDetails',
    pay: 'plan.pay',
    backToLicence: 'general.backToLicence',
    title: 'plan.title',
    planType: 'plan.planType',
    annual: 'plan.annual',
    monthly: 'plan.monthly',
    payPerClick: 'plan.payPerClick',
    freeTrial: 'plan.freeTrial',
    eachYear: 'plan.eachYear',
    eachMonth: 'plan.eachMonth',
    updateCurrentPlan: 'plan.updateCurrentPlan',
    loading: 'general.loading',
    computerHaveInternet: 'plan.computerHaveInternet',
    yes: 'plan.yes',
    no: 'plan.no',
  },
};
